export default {
  areas: ["North", "Central", "South", "East"],

  station_order: [
    2,
    3,
    4,
    11,
    14,
    20,
    1,
    10,
    5,
    6,
    12,
    13,
    16,
    17,
    7,
    8,
    9,
    18,
    19,
    15,
  ],

  stations: [
    {
      id: 1, // field ID
      field: "苗栗獅潭-紙湖農場",
      location: "苗栗獅潭",
      name: "紙湖農場",
      coordinates: [120.9337, 24.5780626],
      text_offsetY: 0,
      area: "Central",

      css_map: {
        style: { top: "19.5%", left: "48%" },
        nameStyle: { top: "22.5%", left: "54%" },
        valueStyle: { top: "18%", left: "26%" }
      },

      line_qrcode_url: "https://line.me/ti/g/wFFBAQxZRg",
      line_url: "line://ti/g/wFFBAQxZRg",
      map_placeID: "紙湖農場",
      map_link: "https://maps.google.com/?cid=1301116395969906128",
      address: "354苗栗縣獅潭鄉苗栗縣獅潭鄉百壽村18號"
    },
    {
      id: 2, // field ID
      field: "桃園龍潭-桃園客家文化館",
      location: "桃園龍潭",
      name: "桃園客家文化館",
      coordinates: [121.2324662, 24.845237],
      text_offsetY: 5,
      area: "North",

      css_map: {
        style: { top: "13.5%", left: "57.5%" },
        nameStyle: { top: "13%", left: "71%" },
        valueStyle: { top: "14%", left: "88%" }
      },

      line_qrcode_url: "https://line.me/ti/g/jkFz0n4zt8",
      line_url: "line://ti/g/jkFz0n4zt8",
      map_placeID: "桃園市客家文化館",
      map_link: "https://maps.google.com/?cid=11296998442151536754",
      address: "325桃園市龍潭區中正路三林段500號"
    },
    {
      id: 3, // field ID
      field: "新竹峨眉-歇心茶樓",
      location: "新竹峨眉",
      name: "歇心茶樓",
      coordinates: [121.0223211, 24.654942],
      text_offsetY: 10,
      area: "North",

      css_map: {
        style: { top: "19%", left: "51%" },
        nameStyle: { top: "20.5%", left: "58%" },
        valueStyle: { top: "19%", left: "72%" }
      },

      line_qrcode_url: "https://line.me/ti/g/KUycp66gUb",
      line_url: "line://ti/g/KUycp66gUb",
      map_placeID: "歇心茶樓",
      map_link: "https://maps.google.com/?cid=12697367363729714055",
      address: "315新竹縣峨眉鄉60-8"
    },
    {
      id: 4, // field ID
      field: "新竹峨眉-十二寮休閒農業園區",
      location: "新竹峨眉",
      name: "十二寮休閒農業園區",
      coordinates: [120.9843867, 24.6744366],
      text_offsetY: -5,
      area: "North",

      css_map: {
        style: { top: "14%", left: "49%" },
        nameStyle: { top: "13.5%", left: "33%" },
        valueStyle: { top: "14%", left: "13%" }
      },

      line_qrcode_url: "https://line.me/ti/g/03VDw0_8L3",
      line_url: "line://ti/g/03VDw0_8L3",
      map_placeID: "十二寮休閒農業園區",
      map_link: "https://maps.google.com/?cid=9662005446487764438",
      address: "315新竹縣峨眉鄉13鄰21號"
    },
    {
      id: 5, // field ID
      field: "苗栗公館-油桐花坊",
      location: "苗栗公館",
      name: "油桐花坊",
      coordinates: [120.8533743, 24.477302],
      text_offsetY: -5,
      area: "Central",

      css_map: {
        style: { top: "24%", left: "45.5%" },
        nameStyle: { top: "25%", left: "52.5%" },
        valueStyle: { top: "24%", left: "67%" }
      },

      line_qrcode_url: "https://line.me/ti/g/VyFEOsEB7K",
      line_url: "line://ti/g/VyFEOsEB7K",
      map_placeID: "油桐花坊",
      map_link: "https://maps.google.com/?cid=11360816415155297452",
      address: "363苗栗縣公館鄉福德村打鹿坑福德35之3號"
    },
    {
      id: 6, // field ID
      field: "苗栗三義-卓也小屋",
      location: "苗栗三義",
      name: "卓也小屋",
      coordinates: [120.7927142, 24.3923541],
      text_offsetY: 5,
      area: "Central",

      // 左邊
      css_map: {
        style: { top: "27%", left: "43%" },
        nameStyle: { top: "27%", left: "33%" },
        valueStyle: { top: "28%", left: "21%" }
      },

      line_qrcode_url: "https://line.me/ti/g/0-kKsBYp0p",
      line_url: "line://ti/g/0-kKsBYp0p",
      map_placeID: "卓也小屋渡假園區",
      map_link: "https://maps.google.com/?cid=3875050485867595391",
      address: "36741苗栗縣三義鄉號"
    },
    {
      id: 7, // field ID
      field: "台中東勢客家文化園區",
      location: "台中東勢",
      name: "東勢客家文化園區",
      coordinates: [120.8296552, 24.2576485],
      text_offsetY: 10,
      area: "Central",

      // 右邊
      css_map: {
        style: { top: "31%", left: "44%" },
        nameStyle: { top: "31%", left: "56%" },
        valueStyle: { top: "31%", left: "77%" }
      },

      line_qrcode_url: "https://line.me/ti/g/OXXwpwb9Va",
      line_url: "line://ti/g/OXXwpwb9Va",
      map_placeID: "東勢客家文化園區",
      map_link: "https://maps.google.com/?cid=7589086140383313164",
      address: "423台中市東勢區中山路1號"
    },
    {
      id: 8, // field ID
      field: "彰化芬園-古生物奇幻樂園",
      location: "彰化芬園",
      name: "古生物奇幻樂園",
      coordinates: [120.6236446, 24.0022222],
      text_offsetY: 10,
      area: "Central",

      css_map: {
        style: { top: "39%", left: "36%" },
        nameStyle: { top: "39%", left: "25%" },
        valueStyle: { top: "43%", left: "13%" } //left: '17.5%'
      },

      line_qrcode_url: "https://line.me/ti/g/tSkPWr2ZfV",
      line_url: "line://ti/g/tSkPWr2ZfV",
      map_placeID: "古生物奇幻樂園",
      map_link: "https://maps.google.com/?cid=12428423781090793637",
      address: "502彰化縣芬園鄉中山路167號"
    },
    {
      id: 9, // field ID
      field: "南投埔里-牛耳藝術渡假村",
      location: "南投埔里",
      name: "牛耳藝術渡假村",
      coordinates: [120.9410505, 23.9656176],
      text_offsetY: 0,
      text_pos: "R",
      area: "Central",

      css_map: {
        style: { top: "40%", left: "47.5%" },
        nameStyle: { top: "44%", left: "50%" },
        valueStyle: { top: "40%", left: "77.5%" }
      },

      line_qrcode_url: "https://line.me/ti/g/FnFVntnYPT",
      line_url: "line://ti/g/FnFVntnYPT",
      map_placeID: "牛耳藝術渡假村",
      map_link: "https://maps.google.com/?cid=14894265519768960929",
      address: "545南投縣埔里鎮中山路四段1號"
    },
    {
      id: 10, // field ID
      field: "苗栗銅鑼-桐花樂活公園",
      location: "苗栗銅鑼",
      name: "桐花樂活公園",
      coordinates: [120.7991388, 24.4710787],
      text_offsetY: 0,
      area: "Central",

      css_map: {
        style: { top: "22%", left: "43%" },
        nameStyle: { top: "23%", left: "31%" },
        valueStyle: { top: "22%", left: "16%" }
      },

      line_qrcode_url: "https://line.me/ti/g/WwmfoPFYo4",
      line_url: "line://ti/g/WwmfoPFYo4",
      map_placeID: "姜太公中部道場(客家大院)",
      map_link: "https://maps.google.com/?cid=18313751187608770981",
      address: "366苗栗縣銅鑼鄉龍泉15號"
    },

    {
      id: 11, // field ID
      field: "新竹新埔-新埔森villa",
      location: "新竹新埔",
      name: "新埔森Villa",
      coordinates: [100, 100],
      text_offsetY: 0,
      area: "North",

      css_map: {
        style: { top: "12.5%", left: "52%" },
        nameStyle: { top: "11%", left: "42%" },
        valueStyle: { top: "11.5%", left: "40%" }
      },

      line_qrcode_url: "https://line.me/ti/g/dEF00yDE84",
      line_url: "line://ti/g/dEF00yDE84",
      map_placeID: "新埔森villa",
      map_link: "https://goo.gl/maps/bDFZoJ1Kbw98dZk46",
      address: "305新竹縣新埔鎮新龍路 752巷38號"
    },
    {
      id: 12, // field ID
      field: "苗栗頭屋-魯冰花休閒農莊",
      location: "苗栗頭屋",
      name: "魯冰花休閒農莊",
      coordinates: [100, 100],
      text_offsetY: 0,
      area: "Central",

      css_map: {
        style: { top: "19.5%", left: "46%" },
        nameStyle: { top: "19%", left: "36%" },
        valueStyle: { top: "18%", left: "24%" }
      },

      line_qrcode_url: "https://line.me/ti/g/-96oyxQCuL",
      line_url: "line://ti/g/-96oyxQCuL",
      map_placeID: "魯冰花休閒農莊",
      map_link: "https://goo.gl/maps/6dyXtL6xzzq1kn4o7",
      address: "362苗栗縣頭屋鄉明德村仁隆21號"
    },
    {
      id: 13, // field ID
      field: "苗栗通霄-上田咖啡休閒莊園",
      location: "苗栗通霄",
      name: "上田咖啡休閒莊園",
      coordinates: [100, 100],
      text_offsetY: 0,
      area: "Central",

      css_map: {
        style: { top: "24%", left: "41%" },
        nameStyle: { top: "25%", left: "28%" },
        valueStyle: { top: "22.5%", left: "19%" }
      },

      line_qrcode_url: "https://line.me/ti/g/PW1FuNEjxX",
      line_url: "line://ti/g/PW1FuNEjxX",
      map_placeID: "上田咖啡休閒莊園",
      map_link: "https://goo.gl/maps/bzWRQ1bxJMVMpnph9",
      address: "35750苗栗縣通霄鎮九鄰93-1號"
    },
    {
      id: 14, // field ID
      field: "新竹關西-馬武督探索森林",
      location: "新竹關西",
      name: "馬武督探索森林",
      coordinates: [100, 100],
      text_offsetY: 0,
      area: "North",

      css_map: {
        style: { top: "15%", left: "57%" },
        nameStyle: { top: "16%", left: "68%" },
        valueStyle: { top: "18%", left: "26%" }
      },

      line_qrcode_url: "https://line.me/ti/g/4Pun6dRRRO",
      line_url: "line://ti/g/4Pun6dRRRO",
      map_placeID: "馬武督探索森林",
      map_link: "https://goo.gl/maps/Q8UKxg2biMMdbESJ9",
      address: "306新竹縣關西鎮12鄰138-3號"
    },
    {
      id: 15, // field ID
      field: "台東鹿野-舊鐵道桐花步道",
      location: "台東鹿野",
      name: "舊鐵道桐花步道",
      coordinates: [100, 100],
      text_offsetY: 0,
      area: "East",

      css_map: {
        style: { top: "67.5%", left: "54%" },
        nameStyle: { top: "71%", left: "58%" },
        valueStyle: { top: "18%", left: "26%" }
      },

      line_qrcode_url: "https://line.me/ti/g/DeFQDqD5Zv",
      line_url: "line://ti/g/DeFQDqD5Zv",
      map_placeID: undefined, //'舊鐵道桐花步道',
      map_src:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3674.528512461671!2d121.14510130000001!3d22.9307551!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346fa50a0925b791%3A0x6bf1572b2bce452!2z6IiK6ZC16YGT5qGQ6Iqx5q2l6YGT!5e0!3m2!1szh-TW!2stw!4v1678870452288!5m2!1szh-TW!2stw",
      map_link: "https://goo.gl/maps/9gkSgrXm3fFkZwkY6",
      address: undefined
    },
    {
      id: 16, // field ID
      field: "苗栗銅鑼-臺灣客家文化館",
      location: "苗栗銅鑼",
      name: "臺灣客家文化館",
      coordinates: [100, 100],
      text_offsetY: 0,
      area: "Central",

      css_map: {
        style: { top: "22.5%", left: "42%" },
        nameStyle: { top: "21%", left: "30%" },
        valueStyle: { top: "18%", left: "26%" }
      },

      line_qrcode_url: "https://line.me/ti/g/sVXc-liFfJ",
      line_url: "line://ti/g/sVXc-liFfJ",
      map_placeID: "臺灣客家文化館",
      map_link: "https://goo.gl/maps/Ycqtbp5czn4VncbG8",
      address: "366003苗栗縣銅鑼鄉銅科南路6號"
    },
    {
      id: 17, // field ID
      field: "苗栗造橋-劍潭古道",
      location: "苗栗造橋",
      name: "劍潭古道",
      coordinates: [100, 100],
      text_offsetY: 0,
      area: "Central",

      css_map: {
        style: { top: "18.5%", left: "45.5%" },
        nameStyle: { top: "17%", left: "38%" },
        valueStyle: { top: "18%", left: "26%" }
      },

      line_qrcode_url: "https://line.me/ti/g/LDr-1y7PTz",
      line_url: "line://ti/g/LDr-1y7PTz",
      map_placeID: "劍潭古道",
      map_link: "https://goo.gl/maps/1Piwkja4aoLaDcqe6",
      address: "361苗栗縣造橋鄉"
    },
    {
      id: 18, // field ID
      field: "嘉義市-幸福山丘",
      location: "嘉義市",
      name: "幸福山丘",
      coordinates: [100, 100],
      text_offsetY: 0,
      area: "South",

      css_map: {
        style: { top: "52.5%", left: "33%" },
        nameStyle: { top: "52.5%", left: "25%" },
        valueStyle: { top: "18%", left: "26%" }
      },

      line_qrcode_url: "https://line.me/ti/g/CczL1ZnbvW",
      line_url: "line://ti/g/CczL1ZnbvW",
      map_placeID: "幸福山丘",
      map_link: "https://goo.gl/maps/n4Y5MKbWMGAAhQ9i9",
      address: "600嘉義市東區東義路566巷52-1號"
    },
    {
      id: 19, // field ID
      field: "花蓮吉安-南華林業園區",
      location: "花蓮吉安",
      name: "南華林業園區",
      coordinates: [100, 100],
      text_offsetY: 0,
      area: "East",

      css_map: {
        style: { top: "38%", left: "66.5%" },
        nameStyle: { top: "42%", left: "68%" },
        valueStyle: { top: "18%", left: "26%" }
      },

      line_qrcode_url: "https://line.me/ti/g/qBzyOw8TD4",
      line_url: "line://ti/g/qBzyOw8TD4",
      map_placeID: "林務局南華站（南華林業園區）",
      map_link: "https://goo.gl/maps/WLZe4Z3VGcNt85he7",
      address: "973花蓮縣吉安鄉吉安路六段117號"
    },
    {
      id: 20, // field ID
      field: "新竹橫山-大山北月",
      location: "新竹橫山",
      name: "大山北月",
      coordinates: [100, 100],
      text_offsetY: 0,
      area: "North",

      css_map: {
        style: { top: "17.5%", left: "53.5%" },
        nameStyle: { top: "18%", left: "62%" },
        valueStyle: { top: "18%", left: "26%" }
      },

      line_qrcode_url: "https://line.me/ti/g/NFUy4Bjcdh",
      line_url: "line://ti/g/NFUy4Bjcdh",
      map_placeID: "大山北月",
      map_link: "https://goo.gl/maps/oSJSoUuC9jyBVB8k6",
      address: "312新竹縣橫山鄉大山背80號"
    }
  ] // end - stations
};
